import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import { APPLICATION_PATHS, ENTITLEMENTS } from '../application-core/constants';
import VocabularyManagerIcon from '../core/icons/VocabularyManager';
import ProjectsManager from '../core/project/ProjectsManager';
import ProjectWrapper from '../core/project/ProjectWrapper';
import StandardAppBar from '../core/StandardAppBar';
import VocabularyManager from './VocabularyManager';
import CreateVocabularyProject from './vocabularyproject/CreateVocabularyProject';
import VocabularyProject from './vocabularyproject/VocabularyProject';

class VocabularyApplication extends Component {

  render() {

    return (
      <React.Fragment>
        <Switch>
          <Route exact path={APPLICATION_PATHS.TAXONOMY_MANAGER} render={
            (props) => <ProjectsManager {...props}
              appBar={<StandardAppBar title="Vocabulary Manager" />}
              projectCreator={CreateVocabularyProject}
              projectType="TaxonomyProject"
              lockedGraphs={this.props.lockedGraphs}
              entitlement={ENTITLEMENTS.CREATE_TAXONOMY_PROJECT}
              homeIcon={{
                name: "Vocabulary Manager Home",
                url: '',
                icon: <VocabularyManagerIcon/>
              }}
              projectClass="https://grafsync.graphifi.com/schema/gs/TaxonomyProject"
              applicationTitle="Vocabulary Manager"
              applicationURL={APPLICATION_PATHS.TAXONOMY_MANAGER}
            />
          } />
          <Route path={APPLICATION_PATHS.TAXONOMY_MANAGER + "/project"} render={
            (props) => <ProjectWrapper {...props}
              component={VocabularyProject}
              loadKey={this.props.loadKey}
              lockedGraphs={this.props.lockedGraphs}
              applicationTitle="Vocabulary Manager"
              applicationURL={APPLICATION_PATHS.TAXONOMY_MANAGER}
            />
          } />
          <Route path={APPLICATION_PATHS.TAXONOMY_MANAGER} render={
            (props) => <VocabularyManager {...props}
              applicationTitle="Vocabulary Manager"
              applicationURL={APPLICATION_PATHS.TAXONOMY_MANAGER}
            />
          } />
        </Switch>
      </React.Fragment>
    );
  }
}

VocabularyApplication.propTypes = {
  lockedGraphs: PropTypes.array,
  loadKey: PropTypes.string
};

export default VocabularyApplication;